import { createApp } from 'vue'
import { createPinia } from 'pinia'
import InterviewQuestionary from './components/InterviewQuestionary/InterviewQuestionary.vue'
import FilterPage from './components/FilterPage/FilterPage.vue'
import PlaylistPage from './components/PlaylistPage/PlaylistPage.vue'
import TourHybridDetailsMap from './components/TourDetailsMap/TourHybridDetailsMap.vue'
import NewsletterPopupVue from './components/NewsletterPopup/NewsletterPopup.vue'
import { router } from './filterRouter'

import './styles/styles.scss'
import 'external-svg-loader'

const pinia = createPinia()

//#region Interview questionary attach
const interviewSelector = 'vue-interview-questionary-component'
const interviewSection = document.getElementById(interviewSelector)
if (interviewSection) {
    const rootsAttrs = interviewSection.dataset
    const app = createApp(InterviewQuestionary, { ...rootsAttrs })

    app.use(pinia)
    app.mount(`#${interviewSelector}`)
}
//#endregion

//#region Playlist attach
const playlistSelector = 'vue-playlist-page-content'
const playlistSection = document.getElementById(playlistSelector)
if (playlistSection) {
    const rootsAttrs = playlistSection.dataset
    const app = createApp(PlaylistPage, { ...rootsAttrs })

    app.use(pinia)
    app.mount(`#${playlistSelector}`)
}
//#endregion

//#region Filter page attach
const filterPageSelector = 'vue-filter-page-component'
const filterPageSection = document.getElementById(filterPageSelector)
if (filterPageSection) {
    const rootsAttrs = filterPageSection.dataset
    const app = createApp(FilterPage, { ...rootsAttrs })

    app.use(pinia)
    app.use(router)
    app.mount(`#${filterPageSelector}`)
}
//#endregion

//#region Newsletter Popup attach
const isMobile = window.innerWidth < 991.98;
const newsletterPopupContainerSelector = isMobile ? 'vue-newsletter-popup-wrapper-mobile' :  'vue-newsletter-popup-wrapper'
const newsletterPopupContainerSection = document.getElementById(newsletterPopupContainerSelector)
if (newsletterPopupContainerSection) {
    const rootsAttrs = newsletterPopupContainerSection.dataset
    const app = createApp(NewsletterPopupVue, { ...rootsAttrs })

    app.use(pinia)
    app.mount(`#${newsletterPopupContainerSelector}`)
}
//#endregion

//#region Tour Hybrid Map page
const tourHybridMapSelector = 'vue-tour-hybrid-map-component'
const tourHybridMapSection = document.getElementById(tourHybridMapSelector)
if (tourHybridMapSection) {
    const rootsAttrs = tourHybridMapSection.dataset
    const app = createApp(TourHybridDetailsMap, { ...rootsAttrs })

    app.use(pinia)
    app.mount(`#${tourHybridMapSelector}`)
}
//#endregion
